// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import MultiSelect from 'multiselect-two-sides';

/**
 * MULTI SELECT - TWO SIDES
 *
 * url:
 * https://crlcu.github.io/multiselect/
 */


export default class MultiSelectTwoSides extends WebComponent {
	didMount () {

	}
}




// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/MultiSelectTwoSides.js